import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./Faq'));

function LoadableFaq() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadableFaq;

